import { render, staticRenderFns } from "./addDoctor.vue?vue&type=template&id=0d23e066"
import script from "./addDoctor.vue?vue&type=script&lang=js"
export * from "./addDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports